import { sharedWorkflowStepNames, type DocumentReview } from "./helpers";
import { useText } from "./text";
import { WorkflowStepSwatch } from "./WorkflowStepSwatch";

export const WorkflowStepLegend = ({
  documentReviews,
}: {
  documentReviews: DocumentReview[];
}) => {
  const text = useText();

  return (
    <ul className="text-muted-foreground flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
      {sharedWorkflowStepNames(documentReviews).map((name, order) => (
        <li key={order} className="flex items-center gap-1.5">
          <WorkflowStepSwatch order={order} />
          {name ?? text.workflowStep.numbered(order + 1)}
        </li>
      ))}
    </ul>
  );
};
